module.exports = __webpack_public_path__ + "img/botanica.1100dad3.webp";